import {HeaderTitle} from "../../../../common/HeaderTitle.jsx";
import {Container, Form} from "react-bootstrap";
import {useParams} from "react-router-dom";
import {Input, Textarea} from "../../../../common/inputs/index.js";
import {useState} from "react";
import {usePozycjaKonfiguracji} from "../../../../../api/domain/konfiguracja/queries/usePozycjaKonfiguracji.jsx";
import Editor from "react-simple-code-editor";
import vsLight from 'prism-react-renderer/themes/vsLight'
import Highlight, {defaultProps} from "prism-react-renderer";

const ViewEdycjaPozycjiKonfiguracji = () => {
    const {tryb, id: konfiguracja} = useParams()
    const titleName = `Edycja konfiguracji Id ${konfiguracja}`

    const pozycjaKonfiguracji = usePozycjaKonfiguracji(konfiguracja)
    const [formData] = useState(tryb === 'dodaj' ? {} : pozycjaKonfiguracji.data)

    const styles = {
        boxSizing: 'border-box',
        fontFamily: '"Dank Mono", "Fira Code", monospace',
        ...vsLight.plain,
        backgroundColor: '#f8f9fa',

    }
    // @ podkreśl syntax
    const highlight = (code, lang) => {


        return <Highlight
            {...defaultProps}
            code={code}
            title={'code'}
            language={lang}
        >
            {({tokens, getLineProps, getTokenProps}) => (
                <>
                    {tokens.map((line, i) => (
                        <div key={i}  {...getLineProps({line, key: i})}>
                            {line.map((token, key) => (
                                <span key={i + key} {...getTokenProps({token, key})} />
                            ))}
                        </div>
                    ))}
                </>
            )}
        </Highlight>
    }

    return (
        <div>
            <HeaderTitle
                breadcrumbLinks={[
                    {label: `Lista dostępnych konfiguracji`, to: '/oper/konfiguracja/lista'},
                    {label: titleName},
                ]}
                home
                destination={`/oper/konfiguracja/lista`}
                size={'fs-3'}
                nav
                title={titleName}/>
            <Container className={'d-flex flex-column gap-3'}>
                <Input
                    className={'mt-2'}
                    label={'Grupa'}
                    value={formData?.group || ''}
                />
                <Input
                    className={'mt-2'}
                    label={'Klucz'}
                    value={formData?.key || ''}
                />
                <Input
                    className={'mt-2'}
                    label={'Typ'}
                    value={formData?.type || ''}

                />
                {formData?.type === 'json' ?
                    (<>
                        <div>
                            <Form.Label htmlFor={'editor'} className={'mt-3 fw-bold'} column={true}>
                                Wartość JSON
                            </Form.Label>

                        </div>

                        <Editor
                            id={'editor'}
                            value={JSON.stringify(formData?.value || {}, null, 2)}
                            onValueChange={() => null}
                            // TODO - zaimplementować zapisywanie zmian w edytorze / również w LSI jako czysty json
                            // onValueChange={(code) => {
                            //     try {
                            //         const parsed = JSON.parse(code);
                            //         setFormState('value', parsed);
                            //     } catch (e) {
                            //         console.error("Invalid JSON:", e);
                            //     }
                            // }}
                            highlight={(code) => highlight(code, 'json')}
                            padding={10}
                            aria-label={'JSON'}
                            textareaClassName={'highligther'}
                            style={styles}/>

                    </>)
                    : <Textarea
                        className={'mt-2'}
                        rows={3}
                        label={'Wartość'}
                        value={formData?.value || ''}
                    />
                }

                <Textarea
                    className={'mt-2'}
                    rows={3}
                    label={'Opis'}
                    value={formData?.desc || ''}
                />

            </Container>
        </div>
    );
}
export default ViewEdycjaPozycjiKonfiguracji
